import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Transition, TRANSITION_TIMING_FUNCTION } from '@oneToOne/shared/styles'

import { Image } from '@core/components/Image'

const idleMinimizedTiming = '0.6s'

const FadeOutAndRight = css`
  animation-name: fadeOutAndRight;
  animation-duration: ${idleMinimizedTiming};
  animation-timing-function: ${TRANSITION_TIMING_FUNCTION};
  animation-fill-mode: forwards;
  opacity: 0;

  @keyframes fadeOutAndRight {
    from {
      opacity: 1;
      transform: translateX(0);
    }

    to {
      opacity: 0;
      transform: translateX(25px);
    }
  }
`

const FadeOutAndRightTwo = css`
  animation-name: fadeOutAndRight;
  animation-duration: ${idleMinimizedTiming};
  animation-timing-function: ${TRANSITION_TIMING_FUNCTION};
  animation-fill-mode: forwards;
  opacity: 0;

  @keyframes fadeOutAndRight {
    from {
      opacity: 1;
      transform: translateX(0);
    }

    to {
      opacity: 0;
      transform: translateX(50px);
    }
  }
`

export const AvatarImage = styled.div<{
  isLarge: boolean
  isHiding: boolean
}>`
  ${Transition}
  position: relative;
  height: ${({ isLarge }) => (isLarge ? '70px' : '50px')};
  width: ${({ isLarge }) => (isLarge ? '70px' : '50px')};
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  background: var(--white);
  padding: var(--spacing-4);

  box-shadow: var(--box-shadow);

  &:nth-of-type(1) {
    ${({ isHiding }) => isHiding && FadeOutAndRightTwo}
  }

  &:nth-of-type(2) {
    margin-left: -25px;
    ${({ isHiding }) => isHiding && FadeOutAndRight}
  }

  &:nth-of-type(3) {
    margin-left: -25px;
  }
`

export const AgentImageMulti = styled(Image)`
  position: absolute;
  width: calc(100% - var(--spacing-6));
  height: calc(100% - var(--spacing-6));
  object-fit: cover;
  object-position: top;
  border-radius: 50%;
`

export const MultiAgentImageWrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: auto;
  height: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border: 0;
`
